import React from "react";
import MicroFrontend from "../Microfrontend";
import "./styles.css";
import "./styles.scss";

const Meeting = ({ history, host }) => {
  const ZoomMeetings = ({ history }) => {
    return (
      <div>
        <div className="home">
          <MicroFrontend history={history} host={host} name="Meeting" />
        </div>
      </div>
    );
  };

  return (
    <div className="main-inner" style={{ paddingTop: "76px" }}>
      {/* <section className="communication-room">
        <div className="communication-room-inner"> */}
      <ZoomMeetings history={history} />
      {/* </div> */}
      {/* </section> */}
    </div>
  );
};

export default Meeting;
